import { Fragment, useMemo, useState } from "react";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable";
import { createColumnHelper } from "@tanstack/react-table";
import { getAdministratorColumns } from "../../Components/admin/administrator.columns";
import { AdministratorModal } from "../../Components/admin/AdministratorModal";

export const AdministratorList = () => {
  const { getData } = useDataFetch();

  const { data, isLoading } = getData(["administrators"], "/administrators/all", { enabled: true });



  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    email: "",
    password: "",
    role: "ADMIN",
  });
  const [isPasswordEdit, setIsPasswordEdit] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
    setIsPasswordEdit(false);
    setFormData({ id: "", name: "", email: "", password: "", role: "ADMIN" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };



  const handleEdit = (admin) => {
    setIsPasswordEdit(false);
    setFormData({
      id: admin.id,
      name: admin.name,
      email: admin.email,
      password: "",
      role: admin.role,
    });
    setModalOpen(true);
  };

  const handleEditPassword = (admin) => {
    setIsPasswordEdit(true);
    setFormData({
      id: admin.id,
      name: admin.name,
      email: admin.email,
      password: "",
      role: admin.role,
    });
    setModalOpen(true);
  };

  const columnHelper = createColumnHelper();

  const columns = useMemo(
    () =>
      getAdministratorColumns(
        columnHelper,
        handleEdit,
        handleEditPassword
      ),
    [columnHelper]
  );

  const admins = data?.data?.administrators ?? [];

  return (
    <Fragment>
      <Breadcrumbs parent="Administradores" title="Registros" mainTitle="Listado de Administradores" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <div className="d-flex justify-content-end px-3 pt-3">
                <Btn
                  attrBtn={{
                    color: "success",
                    size: "sm",
                    id: "create-admin-btn",
                    onClick: () => {
                      setIsPasswordEdit(false);
                      setFormData({ id: "", name: "", email: "", password: "", role: "ADMIN" });
                      setModalOpen(true);
                    },
                  }}
                >
                  <i className="fa fa-user-plus"></i> Registrar Administrador
                </Btn>
                {modalOpen && (
                  <UncontrolledTooltip placement="top" target="create-admin-btn">
                    Registrar Administrador
                  </UncontrolledTooltip>
                )}
              </div>

              <CardBody>
                <DataTable
                  data={admins}
                  columns={columns}
                  noHeader
                  pagination
                  paginationServer
                  highlightOnHover
                  striped
                  responsive
                  progressPending={isLoading}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Modal de Registro / Edición */}
      <AdministratorModal
        modalOpen={modalOpen}
        formData={formData}
        isPasswordEdit={isPasswordEdit}
        handleChange={handleChange}
        closeModal={closeModal}
      />
    </Fragment>
  );
};
